import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RatingReviewModal } from "./types";

const initialState: RatingReviewModal = {
  batchesReviewListing: {
    data: [],
    total: 0,
    pageNo: 0,
    totalPage: 0,
    nextHit: 0,
    limit: 0,
    totalCount: 0,
  },

  batchesReviewListQueryParameters: {
    pageNo: 1,
    limit: 10,
    sortBy: "1",
    sortCriteria: "createdAt",
  },

  previousBatchesReviewListing: {
    data: [],
    total: 0,
    pageNo: 0,
    totalPage: 0,
    nextHit: 0,
    limit: 0,
    totalCount: 0,
  },

  previousBatchesReviewListQueryParameters: {
    pageNo: 1,
    limit: 10,
    sortBy: "1",
    sortCriteria: "createdAt",
  },
};

const RatingReviewSlice = createSlice({
  name: "RatingReviewSlice",
  initialState,
  reducers: {
    setBatchesReviewListData: (
      state: RatingReviewModal,
      action: PayloadAction<RatingReviewModal["batchesReviewListing"]>,
    ) => {
      if (action.payload.pageNo === 1) {
        state.batchesReviewListing.data = [...action.payload.data];
      } else {
        state.batchesReviewListing.data = [
          ...state.batchesReviewListing.data,
          ...action.payload.data,
        ];
      }
      state.batchesReviewListing.total = action.payload.total;
      state.batchesReviewListing.pageNo = action.payload.pageNo;
      state.batchesReviewListing.totalPage = action.payload.totalPage;
      state.batchesReviewListing.nextHit = action.payload.nextHit;
      state.batchesReviewListing.limit = action.payload.limit;
      state.batchesReviewListing.totalCount = action.payload.totalCount;
    },

    setBatchesReviewListQueryParameters: (
      state: RatingReviewModal,
      action: PayloadAction<
        RatingReviewModal["batchesReviewListQueryParameters"]
      >,
    ) => {
      state.batchesReviewListQueryParameters = { ...action.payload };
    },

    setPreviousBatchesReviewListData: (
      state: RatingReviewModal,
      action: PayloadAction<RatingReviewModal["previousBatchesReviewListing"]>,
    ) => {
      if (action.payload.pageNo === 1) {
        state.previousBatchesReviewListing.data = [...action.payload.data];
      } else {
        state.previousBatchesReviewListing.data = [
          ...state.previousBatchesReviewListing.data,
          ...action.payload.data,
        ];
      }
      state.previousBatchesReviewListing.total = action.payload.total;
      state.previousBatchesReviewListing.pageNo = action.payload.pageNo;
      state.previousBatchesReviewListing.totalPage = action.payload.totalPage;
      state.previousBatchesReviewListing.nextHit = action.payload.nextHit;
      state.previousBatchesReviewListing.limit = action.payload.limit;
      state.previousBatchesReviewListing.totalCount = action.payload.totalCount;
    },

    setPreviousBatchesReviewListQueryParameters: (
      state: RatingReviewModal,
      action: PayloadAction<
        RatingReviewModal["previousBatchesReviewListQueryParameters"]
      >,
    ) => {
      state.previousBatchesReviewListQueryParameters = { ...action.payload };
    },

    clearBatchesReviewListData: (state: RatingReviewModal) => {
      state.batchesReviewListing = {
        data: [],
        total: 0,
        pageNo: 0,
        totalPage: 0,
        nextHit: 0,
        limit: 0,
        totalCount: 0,
      };
      state.batchesReviewListQueryParameters = {
        pageNo: 1,
        limit: 10,
        sortBy: "1",
        sortCriteria: "createdAt",
      };
    },

    clearPreviousBatchesReviewListData: (state: RatingReviewModal) => {
      state.previousBatchesReviewListing = {
        data: [],
        total: 0,
        pageNo: 0,
        totalPage: 0,
        nextHit: 0,
        limit: 0,
        totalCount: 0,
      };
      state.previousBatchesReviewListQueryParameters = {
        pageNo: 1,
        limit: 10,
        sortBy: "1",
        sortCriteria: "createdAt",
      };
    },
  },
});

export const {
  setBatchesReviewListData,
  clearBatchesReviewListData,
  setPreviousBatchesReviewListData,
  clearPreviousBatchesReviewListData,
  setBatchesReviewListQueryParameters,
  setPreviousBatchesReviewListQueryParameters,
} = RatingReviewSlice.actions;

export default RatingReviewSlice.reducer;
